import HTTP from '@api';

import { generateXHRError } from '@helpers';

export default {
  namespaced: true,
  state: {
    messages: [],
  },
  mutations: {
    setMessages(state, payload) {
      state.messages = payload;
    },
  },
  actions: {
    async getMessages({ commit, rootState: { locations } }, {
      suffix = locations.suffix,
      outerId = null, state = null,
      pageNum = 1, pageSize = 10,
    }) {
      try {
        const { data } = await HTTP.get(`${suffix}/message`, {
          params: {
            suffix, outerId, state, pageNum, pageSize,
          },
        });
        commit('setMessages', data || []);
        return Promise.resolve();
      } catch (e) {
        return Promise.reject(generateXHRError(e));
      }
    },
  },
};
